import {
  Component,
  OnInit,
  forwardRef,
  Input,
  OnChanges,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
} from '@angular/core';
import {
  NG_VALUE_ACCESSOR,
  ControlValueAccessor,
  NG_VALIDATORS,
  Validator,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';

@Component({
  selector: 'form-input-regex',
  templateUrl: './input-regex.component.html',
  styleUrls: ['./input-regex.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputRegexComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputRegexComponent),
      multi: true,
    },
  ],
})
export class InputRegexComponent implements OnInit, OnChanges, ControlValueAccessor, Validator {
  @Input() maxlength = 250;
  @Input() id = '';
  @Input() type = 'text';
  @Input() label = '';
  @Input() required = true;
  @Input() disabled = false;
  @Input() regex = /[0-9]|\./;
  @Input() regexInput;
  @Input() hasTwoRegex = false;
  @Input() placeholder = '';
  @Input() inputmode = '';
  @Input() iconCheck = false;
  @Input() iconError = false;
  @Input() iconBlock = false;
  @Input() spinner = false;
  @Input() halfBorder = false;
  @Input() halfBorderLeft = false;
  @Input() flag: boolean;
  @Input() hasError: boolean;

  @Output() blur: EventEmitter<any>;
  @Output() keyUp: EventEmitter<any>;
  @ViewChild('input') input: ElementRef;
  public value: string;
  public valueUpdated: string;
  public isDisabled: boolean;
  private _onChange = (_: any) => {};
  private _onTouch = () => {};

  constructor() {
    this.blur = new EventEmitter();
    this.keyUp = new EventEmitter();
  }

  ngOnInit() {
    this.value = '';
    this.valueUpdated = '';
  }
  ngOnChanges() {
    if (!(this.regex instanceof RegExp)) {
      this.regex = new RegExp(this.regex);
    }

    if (!this.hasTwoRegex) {
      this.regexInput = this.regex;
    }
  }

  onInput(event) {
    const value = event.data;
    const currentValue = event.target.value;
    this._onTouch();

    if (!value) {
      if (currentValue === '' || this.regexInput.test(currentValue)) {
        this.valueUpdated = currentValue;
      } else {
        event.target.value = this.valueUpdated;
      }
      return;
    }
    if (!this.regexInput.test(value)) {
      event.target.value = this.valueUpdated;
      return;
    }
    this.valueUpdated = event.target.value;
    this.keyUp.next(this.valueUpdated);
  }

  updateValue() {
    this.value = this.valueUpdated;
    this._onChange(this.value);
  }

  onBlurValue(event) {
    const { target } = event;
    this.blur.next(target.value);
    this.value = this.valueUpdated;
    this._onChange(this.value);
  }

  writeValue(value: any): void {
    this.value = value ? value + '' : '';
  }
  registerOnChange(fn: any): void {
    this._onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this._onTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    if (this.required && this.valueUpdated.length === 0) {
      return { required: 'Value is required' };
    }
    if (this.valueUpdated.length > 0 && !this.regex.test(this.valueUpdated)) {
      return { regex: 'Please fill a valid value' };
    }
  }
}
